var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-address',_vm._b({model:{value:(_vm.nativeValue),callback:function ($$v) {_vm.nativeValue=$$v},expression:"nativeValue"}},'vue-address',_vm.conf,false))}
var staticRenderFns = []

export { render, staticRenderFns }